export const teamWorkflow = {
  junior: {
    processes: [
      { name: 'Daily Standup', description: 'Share infrastructure work, deployments, and blockers', time: '9:00 AM daily' },
      { name: 'Infrastructure Code Review', description: 'Review Terraform, Ansible, and CI/CD configurations', requirement: 'All infrastructure changes require peer review' },
      { name: 'Deployment Process', description: 'Follow deployment procedures and rollback plans', coverage: 'All deployments must have rollback strategy' }
    ],
    responsibilities: [
      { area: 'Infrastructure Maintenance', tasks: ['Monitor system health', 'Apply security patches', 'Update configurations', 'Document changes'] },
      { area: 'CI/CD Support', tasks: ['Maintain build pipelines', 'Troubleshoot deployment issues', 'Optimize build times', 'Support development teams'] },
      { area: 'Monitoring & Alerting', tasks: ['Configure monitoring', 'Respond to alerts', 'Create dashboards', 'Maintain documentation'] }
    ],
    ceremonies: [
      { name: 'Sprint Planning', frequency: 'Bi-weekly', duration: '2 hours', role: 'Plan infrastructure work' },
      { name: 'Infrastructure Review', frequency: 'Weekly', duration: '1 hour', role: 'Review system status' },
      { name: 'Post-mortem', frequency: 'As needed', duration: '1 hour', role: 'Learn from incidents' }
    ]
  },
  mid: {
    processes: [
      { name: 'Architecture Planning', description: 'Plan infrastructure architecture and scaling', frequency: 'Weekly' },
      { name: 'On-call Rotation', description: 'Participate in infrastructure on-call rotation', responsibility: 'Primary incident response' },
      { name: 'Capacity Planning', description: 'Monitor and plan infrastructure capacity', scope: 'Resource optimization' }
    ],
    responsibilities: [
      { area: 'System Architecture', tasks: ['Design scalable systems', 'Plan infrastructure upgrades', 'Optimize performance', 'Lead technical discussions'] },
      { area: 'Automation', tasks: ['Build automation tools', 'Improve CI/CD pipelines', 'Automate manual processes', 'Mentor junior engineers'] },
      { area: 'Security & Compliance', tasks: ['Implement security measures', 'Ensure compliance', 'Conduct security reviews', 'Manage secrets'] }
    ],
    ceremonies: [
      { name: 'Architecture Review', frequency: 'Weekly', duration: '2 hours', role: 'Lead infrastructure architecture' },
      { name: 'Capacity Planning', frequency: 'Monthly', duration: '2 hours', role: 'Analyze and plan capacity' },
      { name: 'Security Review', frequency: 'Bi-weekly', duration: '1 hour', role: 'Review security posture' }
    ]
  },
  senior: {
    processes: [
      { name: 'Strategic Planning', description: 'Define infrastructure strategy and technology roadmap', scope: 'Company-wide infrastructure' },
      { name: 'Technical Leadership', description: 'Lead major infrastructure initiatives', responsibility: 'Infrastructure architecture ownership' },
      { name: 'Cross-team Coordination', description: 'Coordinate infrastructure needs across teams', impact: 'Organization-wide efficiency' }
    ],
    responsibilities: [
      { area: 'Strategic Leadership', tasks: ['Define infrastructure strategy', 'Evaluate new technologies', 'Plan technology migrations', 'Drive innovation'] },
      { area: 'Team Management', tasks: ['Lead DevOps teams', 'Mentor senior engineers', 'Drive engineering culture', 'Cross-team collaboration'] },
      { area: 'Enterprise Architecture', tasks: ['Design enterprise systems', 'Plan disaster recovery', 'Ensure high availability', 'Optimize costs'] }
    ],
    ceremonies: [
      { name: 'Infrastructure Leadership', frequency: 'Weekly', duration: '3 hours', role: 'Infrastructure strategy lead' },
      { name: 'Technology Review', frequency: 'Monthly', duration: '4 hours', role: 'Technology evaluation lead' },
      { name: 'Executive Reporting', frequency: 'Monthly', duration: '2 hours', role: 'Infrastructure status reporting' }
    ]
  }
};
